module.exports = __webpack_public_path__ + "static/img/park2.b40d997.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/image/park2.jpg
// module id = AwmP
// module chunks = 1